import Vue from 'vue';
import { Can } from '@casl/vue';

Vue.component('Can', Can);
